export default __webpack_public_path__ + "static/media/Friction3AImg.5efb1227.jpg";